import { render, staticRenderFns } from "./ModifyClassificationModal.vue?vue&type=template&id=41295409&"
import script from "./ModifyClassificationModal.vue?vue&type=script&lang=js&"
export * from "./ModifyClassificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports